import type { CSSProperties } from 'react';
import { cx } from '../../lib/cx.ts';
import './BrandLogo.css';

export const LOGO_SRC = '/brand/natashu-logo.png';

export interface BrandLogoProps {
  /** Rendered height in px. */
  size?: number;
  /**
   * `badge`: logo inside a deep-green rounded tile, for light/dark surfaces (brand.md).
   * `plain`: the logo alone, only on the green gradient or dark panels.
   */
  variant?: 'badge' | 'plain';
  /** Decorative when the product name is shown next to it. */
  decorative?: boolean;
  className?: string;
}

/** The owner's original logo file — scaled only, never redrawn or recoloured. */
export function BrandLogo({ size = 40, variant = 'badge', decorative = false, className }: BrandLogoProps) {
  const alt = decorative ? '' : 'NATASHU';
  if (variant === 'plain') {
    return <img className={cx('brand-logo', className)} src={LOGO_SRC} alt={alt} style={{ height: size, width: 'auto' }} draggable={false} />;
  }
  return (
    <span className={cx('brand-badge', className)} style={{ '--brand-badge-size': `${size}px` } as CSSProperties}>
      <img src={LOGO_SRC} alt={alt} draggable={false} />
    </span>
  );
}
